import React, { useEffect, useState, useCallback } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { ArrowForwardIos } from "@mui/icons-material";
import {
  BrClassification_GetApi,
  BrClassification_Update,
} from "../../Server/ApiV2";
import { exportToExcel, fAlertToast } from "../../Utility/Utilitys";

export default function BranchClassificationPage() {

const isMobile = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);
  const [classificationList, setClassificationList] = useState([]);

  const fetchData = async () => {
    try {
      const res = await BrClassification_GetApi({});
      if (res.status === 200) {
        setRows(res?.data?.BrClassification_Getrow);
        setClassificationList(res?.data?.BrClassification);
      }else{
        fAlertToast("FAILED", res?.response?.data?.error || res?.message);
      }
    } catch (err) {
    }
  };

  const handleClassificationChange = useCallback((uid, newValue) => {
    setRows((prev) =>
      prev.map((row) =>
        row.UId === uid
          ? {
              ...row,
              Clasification: newValue,
              IsRowEdited: true,
            }
          : row
      )
    );
  }, []);

  const handleSave = async () => {
    const edited = rows
      .filter((r) => r.IsRowEdited === true)
      .map((r) => ({
        UId: r.UId,
        Classification: r.Clasification,
      }));
    if (edited.length === 0) {
      fAlertToast("WARNING", `No updates detected. Please edit a row before saving.`);
      return;
    }
    try {
      const res = await BrClassification_Update({ detail: edited });
      if (res.status === 200) {
        fAlertToast("SUCCESS", "Saved Successfully!");
        await fetchData();
      }else{
        fAlertToast("FAILED", res?.response?.data?.error || res?.message);
      }
    } catch (err) {
      console.error("Save Error:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      field: "BranchName",
      headerName: "Branch Name",
      minWidth: isMobile ?160: 350,
    },
    {
      field: "Clasification",
      headerName: "Classification",
      width: isMobile ?175:300,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Box
            sx={{
              background: "#f5f9ff", // LIGHT BG FOR EDITABLE COLUMN
              width: "95%",
              height: "95%",
              display: "flex",
              alignItems: "center",
              borderRadius: 1,
            }}
          >
            <Select
              fullWidth
              size="small"
              value={row.Clasification || ""}
              onChange={(e) =>
                handleClassificationChange(row.UId, e.target.value)
              }
              displayEmpty
            >
              {classificationList && classificationList?.map((item) => (
                <MenuItem className="menuSm" key={item.UId} value={item.UId}>
                  {item.NAME1 || "— Select —"}
                </MenuItem>
              ))}
            </Select>
          </Box>
        );
      },
    },
  ];

  const breadCrumbStyle = {
    color: "#cccccc",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  const breadCrumbActiveStyle = {
    color: "#0288d1",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  return (
    <Box p={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ mb: 1 }}>
          <span style={breadCrumbStyle}>Masters </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "0.5rem" }} />
          <span style={breadCrumbActiveStyle}>Branch Classification</span>
        </Box>
        <Tooltip title="Export CSV">
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              const onlyNecessaryColData =
                rows?.length > 0 &&
                rows?.map((row) => ({
                  Branch: row?.BranchName,
                  Clasification: row?.BrClassificationName,
                }));
              exportToExcel(onlyNecessaryColData, "BranchClassification", "");
            }}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        sx={{
          height: { xs: "78vh", sm: "77vh", md: "76vh",lg:"78vh"},
          marginTop: {xs:"8px",md:"16px"},
        }}
      >
        <DataGridPro
          rows={rows ?? []}
          columns={columns}
          rowHeight={30}
          headerHeight={40}
          getRowId={(row) => row.UId}
          hideFooter
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
        variant="contained"
        color="success"
        sx={{ mt: 2 }}
        size="small"
        onClick={handleSave}
      >
        Save
      </Button>
      </Box>
    </Box>
  );
}
